import { render, staticRenderFns } from "./city_settings.vue?vue&type=template&id=7adf0929&scoped=true&"
import script from "./city_settings.vue?vue&type=script&lang=js&"
export * from "./city_settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adf0929",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7adf0929')) {
      api.createRecord('7adf0929', component.options)
    } else {
      api.reload('7adf0929', component.options)
    }
    module.hot.accept("./city_settings.vue?vue&type=template&id=7adf0929&scoped=true&", function () {
      api.rerender('7adf0929', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/cities/tabs/city_settings.vue"
export default component.exports